import { css } from "lit";
const tooltipDirectiveCss = css`
  :root {
    --tooltip-position-left: 50px;
    --tooltip-position-top: 50px;
    --tooltip-min-width: 2rem;
    --tooltip-max-width: 40rem;
    --tooltip-min-height: 2rem;
    --tooltip-max-height: 40rem;
    --tooltip-background-color: linear-gradient(to bottom, #2b3952, #142033 100%);
    --tooltip-text-color: white;
  }
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  :popover-open {
    position: fixed;
    min-width: var(--tooltip-min-width);
    min-height: var(--tooltip-min-height);
    max-width: var(--tooltip-max-width);
    max-height: var(--tooltip-max-height);
    overflow: hidden;
    inset: unset;
    border: none;
    padding: 5px;
    background: transparent;
    top: var(--tooltip-position-top);
    left: var(--tooltip-position-left);
    animation: 400ms ease-in 1 fade-in;
  }

  #tooltip-container {
    background: var(--tooltip-background-color);
    color: var(--tooltip-text-color);
    border-radius: 5px;
    padding: 8px 10px;
  }

  #tooltip-arrow {
    position: absolute;
    width: var(--arrow-size, 8px);
    height: var(--arrow-size, 8px);
    z-index: -1;
    content: '';
    transform: rotate(45deg);
    background: inherit;
  }

  #tooltip-arrow[position='top'] {
    left: calc(50% - 4px);
    bottom: 1px;
    top: auto;
  }

  #tooltip-arrow[position='bottom'] {
    bottom: auto;
    top: 1px;
    left: calc(50% - 4px);
  }

  #tooltip-arrow[position='left'] {
    top: calc(50% - 4px);
    left: auto;
    right: 1px;
  }

  #tooltip-arrow[position='right'] {
    top: calc(50% - 4px);
    right: auto;
    left: 1px;
  }
`;
let positionTop;
let positionLeft;
function positionTooltip(parentElement, tooltipElement, place, message = null, functionCallCount = 0) {
  const invokerRect = parentElement.getBoundingClientRect();
  if (message) {
    tooltipElement.querySelector("p").textContent = message;
  }
  tooltipElement.showPopover();
  const tooltipRect = tooltipElement.getBoundingClientRect();
  tooltipElement.hidePopover();
  switch (place) {
    case "top":
      if (functionCallCount > 1) {
        place = "bottom";
        console.error("Tooltip is too big to fit in the viewport");
        break;
      }
      positionTop = invokerRect.top - tooltipRect.height;
      positionLeft = invokerRect.left + invokerRect.width / 2 - tooltipRect.width / 2;
      if (positionTop < 0) {
        place = "bottom";
        return positionTooltip(parentElement, tooltipElement, place, message, functionCallCount + 1);
      }
      break;
    case "bottom":
      if (functionCallCount > 1) {
        place = "top";
        console.error("Tooltip is too big to fit in the viewport");
        break;
      }
      positionTop = invokerRect.bottom;
      positionLeft = invokerRect.left + invokerRect.width / 2 - tooltipRect.width / 2;
      if (positionTop + tooltipRect.height > window.innerHeight) {
        place = "top";
        return positionTooltip(parentElement, tooltipElement, place, message, functionCallCount + 1);
      }
      break;
    case "left":
      if (functionCallCount > 1) {
        place = "right";
        console.error("Tooltip is too big to fit in the viewport");
        break;
      }
      positionTop = invokerRect.top + invokerRect.height / 2 - tooltipRect.height / 2;
      positionLeft = invokerRect.left - tooltipRect.width;
      if (positionLeft < 0) {
        place = "right";
        return positionTooltip(parentElement, tooltipElement, place, message, functionCallCount + 1);
      }
      break;
    case "right":
      if (functionCallCount > 1) {
        place = "left";
        console.error("Tooltip is too big to fit in the viewport");
        break;
      }
      positionTop = invokerRect.top + invokerRect.height / 2 - tooltipRect.height / 2;
      positionLeft = invokerRect.right;
      if (positionLeft + tooltipRect.width > window.innerWidth) {
        place = "left";
        return positionTooltip(parentElement, tooltipElement, place, message, functionCallCount + 1);
      }
      break;
  }
  tooltipElement.style.setProperty("--tooltip-position-top", `${positionTop}px`);
  tooltipElement.style.setProperty("--tooltip-position-left", `${positionLeft}px`);
  const arrow = tooltipElement.querySelector("#tooltip-arrow");
  arrow.setAttribute("position", place);
  return true;
}
function getTextWidth(text, context) {
  context.font = getComputedStyle(document.body).font;
  const width = context.measureText(text).width;
  return Math.floor(width);
}
function getMaxTextWidth(texts, width) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  const threeDotsWidth = 27;
  let totalWidth = 0;
  let isOverflow = false;
  let str = "";
  for (const text of texts) {
    totalWidth += getTextWidth(text, context);
    if (totalWidth <= width - threeDotsWidth) {
      str += text;
    } else {
      isOverflow = true;
      break;
    }
  }
  str += "...";
  canvas.remove();
  return { str, isOverflow };
}
export {
  getMaxTextWidth,
  positionTooltip,
  tooltipDirectiveCss
};
//# sourceMappingURL=omni-tooltip-shared.js.map
